<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col>
        <v-card color="transparent" flat>
          <v-card-title class="headline">
            {{ sectionName }} Settings
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-row
            style="background-color:var(--brand-primary-dark)"
            no-gutters=""
            class="pa-2"
          >
            <v-col class="title ml-2" style="color:white">
              Search Settings
            </v-col>
          </v-row>

          <v-container class="pa-2">
            <v-row>
              <v-col cols="12" class="pb-0 pt-0"
                ><v-subheader class="pa-0 ma-0"
                  >Focused attributes</v-subheader
                ></v-col
              >
              <v-col cols="3" class="pb-0 pt-0">
                <attribute-search
                  label="Focused Attributes"
                  v-on:AttributeSelected="
                    (value) => OnFocusedAttributesSelect(value)
                  "
                  :clearResult="false"
                  :multiple="true"
                  :clearable="true"
                  :initalValues="section.focusedAttributes"
                >
                </attribute-search>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-row
            style="background-color:var(--brand-primary-dark)"
            no-gutters=""
            class="pa-2"
          >
            <v-col class="title ml-2" style="color:white">
              Market / Team restrictions
            </v-col>
          </v-row>

          <v-container class="pa-2">
            <v-row>
              <v-col cols="6" v-for="category in categories" :key="category.id">
                <v-card class="pl-2 pr-2 pb-2">
                  <v-card-title class="title">{{ category.name }}</v-card-title>
                  <v-combobox
                    outlined
                    label="Prohibited Markets"
                    v-model="category.prohibitedMarkets"
                    :multiple="true"
                    :clearable="true"
                    :deletable-chips="true"
                    dense
                    hide-details
                    :items="markets"
                    item-text="name"
                    chips
                    item-value="id"
                    :return-object="false"
                    v-on:change="OnChangeCategoryMarkets(category)"
                  >
                    <template v-slot:selection="{ parent, item }">
                      <v-chip>{{ GetNameForMarket(item) }}</v-chip>
                    </template>
                  </v-combobox>
                  <v-combobox
                    outlined
                    label="Read only teams"
                    v-model="category.readOnlyTeams"
                    :multiple="true"
                    :clearable="true"
                    :deletable-chips="true"
                    dense
                    hide-details
                    :items="teams"
                    item-text="teamName"
                    chips
                    item-value="id"
                    :return-object="false"
                    v-on:change="OnChangeCategoryTeam(category)"
                  >
                    <template v-slot:selection="{ parent, item }">
                      <v-chip>{{ GetNameForTeam(item) }}</v-chip>
                    </template>
                  </v-combobox>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-row
            style="background-color:var(--brand-primary-dark)"
            no-gutters=""
            class="pa-2"
          >
            <v-col class="title ml-2" style="color:white">
              Default Catalogue Steps
            </v-col>
            <v-btn
              class="ma-0"
              small
              dense
              color="green"
              dark
              :disabled="!hasBeenChanges"
              @click="ApplyChanges()"
            >
              <span class="pa-2 pl-4">Apply Changes</span>
              <v-icon left light>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </v-row>

          <v-container class="pa-2">
            <v-row
              name="Catalogue steps"
              v-for="(step, index) in catalogue.steps"
              :key="index"
              class="pa-2"
            >
              <v-col cols="3" class="pb-0 pt-0">
                <v-text-field
                  label="Prefix"
                  hide-details=""
                  height="28px"
                  v-model="step.prefix"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3" class="pb-0 pt-0">
                <attribute-search
                  v-on:AttributeSelected="
                    (value) => OnAttributeSelected(step, value)
                  "
                  label="Step Attribute"
                  :clearResult="false"
                  :initalValues="step.attribute"
                >
                </attribute-search>
              </v-col>
              <!--
                            <v-col cols="3" class="pb-0 pt-0">
                                <attribute-search v-on:AttributeSelected="(value) => OnFilterSelected(step,value)" label="Filter" :clearResult="false" :multiple="true" :clearable="true" :initalValues="step.filters">

                                </attribute-search>
                            </v-col>
                            -->
              <v-col cols="2" class="pb-0 pt-0">
                <v-switch
                  v-model="step.allowMultiple"
                  v-on:change="hasBeenChanges = true"
                  hide-details=""
                  dense
                  label="Multiple"
                ></v-switch>
              </v-col>
              <v-col cols="1" class="pb-0 pt-0">
                <v-btn icon="" v-on:click="RemoveStep(index)">
                  <v-icon color="red">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>
            <v-spacer> </v-spacer>
            <v-btn dense class="ma-0" v-on:click="AddNewStep" small>
              Add New Step
            </v-btn>
          </v-card-actions>

          <v-divider></v-divider>

          <v-row justify="center" align="center">
            <v-col cols="6">
              <span class="pa-2 title">
                Category overides
              </span>
            </v-col>
            <v-spacer> </v-spacer>
            <category-search
              class="pa-4"
              :filled="true"
              v-on:CategorySelected="AddnewOveride"
              :clearAfterSelect="true"
              :sectionid="section.id"
            >
            </category-search>
          </v-row>

          <v-divider></v-divider>

          <v-container class="pa-2">
            <v-card
              class="ma-2"
              v-for="(overide, index) in catalogue.categoryOverides"
              :key="index"
            >
              <v-card-title class="subtitle-1 pa-2">
                <span class="subtitle-1">
                  {{ overide.name }}
                </span>
                <v-spacer> </v-spacer>
                <v-btn @click="RemoveOveride(index)" small>
                  Remove Overide
                </v-btn>
              </v-card-title>
              <v-container class="pa-2">
                <v-row
                  name="Catalogue steps"
                  v-for="(step, index) in overide.steps"
                  :key="index"
                  class="pa-2"
                >
                  <v-col cols="3" class="pb-0 pt-0">
                    <v-text-field
                      label="Prefix"
                      hide-details=""
                      height="28px"
                      v-model="step.prefix"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3" class="pb-0 pt-0">
                    <attribute-search
                      v-on:AttributeSelected="
                        (value) => OnAttributeSelected(step, value)
                      "
                      label="Step Attribute"
                      :clearResult="false"
                      :initalValues="step.attribute"
                    >
                    </attribute-search>
                  </v-col>
                  <!--
                                    <v-col cols="3" class="pb-0 pt-0">
                                        <attribute-search v-on:AttributeSelected="(value) => OnFilterSelected(step,value)" label="Filter" :clearResult="false" :multiple="true" :clearable="true" :initalValues="step.filters">

                                        </attribute-search>
                                    </v-col>
                                    -->
                  <v-col cols="2" class="pb-0 pt-0">
                    <v-switch
                      v-model="step.allowMultiple"
                      v-on:change="hasBeenChanges = true"
                      hide-details=""
                      dense
                      label="Multiple"
                    ></v-switch>
                  </v-col>
                  <v-col cols="1" class="pb-0 pt-0">
                    <v-btn
                      icon=""
                      v-on:click="RemoveOverideStep(overide, index)"
                    >
                      <v-icon color="red">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>

              <v-card-actions>
                <v-spacer> </v-spacer>
                <v-btn
                  dense
                  class="ma-0"
                  v-on:click="AddOverideStep(overide)"
                  small
                >
                  Add New Step
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="loaded">
      <AssetDetailTemplateBuilder></AssetDetailTemplateBuilder>
    </v-row>
  </v-container>
</template>

<script>
import CONFIG from "../../../appconfig.json";
import AttributeSearch from "../../attributes/AttributeSearch";
import AssetDetailTemplateBuilder from "../../views/AssetDetailTemplateBuilder.vue";
import CategorySearch from "../../category/CategorySearch.vue";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  components: {
    AttributeSearch,
    AssetDetailTemplateBuilder,
    CategorySearch,
  },
  props: {
    //Name to use for section title
    sectionName: {
      default: "",
      type: String,
    },
  },
  computed: {},
  data: () => ({
    markets: [],
    categories: [],
    section: {},
    catalogue: {
      steps: [],
    },
    hasBeenChanges: false,
    teams: [],
    loaded: false,
  }),
  mounted: function() {
    this.loaded = false;

    this.GetSection(this.sectionName).then(() => {
      this.GetSectionData(this.sectionName).then((section) => {
        this.GetCategoriesForSection(this.sectionName).then((categories) => {
          this.GetMarkets().then((markets) => {
            this.GetTeams().then((teams) => {
              this.catalogue = section.catalogue;
              this.section = section;
              this.markets = markets;
              this.teams = teams;

              if (this.catalogue == null) {
                this.catalogue = { steps: [] };
              } else if (this.catalogue.steps == null) {
                this.catalogue.steps = [];
              }

              this.categories = categories;
              console.log("Got cats", this.categories);
              console.log("Got teams", this.teams);

              this.loaded = true;
            });
          });
        });
      });
    });
  },
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets", "GetAuthHeaderObj"]),

    ...mapActions("assetxpstate", [
      "GetSection",
      "SetSectionFocusedAttributes",
      "CreateSection",
      "GetSectionData",
      "UpdateSectionCatalogue",
      "GetCategoriesForSection",
      "GetMarkets",
      "GetTeams",
      "UpsertCategoryInSection",
    ]),

    OnChangeCategoryMarkets(category) {
      this.UpsertCategoryInSection(category);
    },
    OnChangeCategoryTeam(category) {
      this.UpsertCategoryInSection(category);
    },
    OnFocusedAttributesSelect(attributes) {
      this.SetSectionFocusedAttributes(attributes);
    },
    OnAttributeSelected(step, attribute) {
      this.hasBeenChanges = true;
      step.attribute = attribute;
    },
    OnFilterSelected(step, attributes) {
      this.hasBeenChanges = true;
      step.filters = attributes;
    },
    AddnewOveride(category) {
      if (this.catalogue.categoryOverides == null)
        this.catalogue.categoryOverides = [];

      var anyMatches = this.catalogue.categoryOverides.filter(
        (overide) => overide.id == category.id
      );

      if (anyMatches.length == 0) {
        this.hasBeenChanges = true;
        this.catalogue.categoryOverides.push({
          id: category.id,
          name: category.name,
          steps: [],
        });
      }
    },
    RemoveOveride(index) {
      this.hasBeenChanges = true;
      this.catalogue.categoryOverides.splice(index, 1);
    },
    AddNewStep() {
      this.hasBeenChanges = true;
      this.catalogue.steps.push({
        prefix: "",
        attribute: null,
        filters: [],
        allowMultiple: false,
      });
    },
    RemoveStep(index) {
      this.hasBeenChanges = true;
      this.catalogue.steps.splice(index, 1);
    },
    RemoveOverideStep(overide, index) {
      this.hasBeenChanges = true;
      overide.steps.splice(index, 1);
    },
    AddOverideStep(overide) {
      overide.steps.push({
        prefix: "",
        attribute: null,
        filters: [],
        allowMultiple: false,
      });
    },
    GetNameForMarket(marketid) {
      var foundMarket = this.markets.find(
        (innerItem) => innerItem.id == marketid
      );

      if (foundMarket != null) return foundMarket.name;
      else return "Deleted Market";
    },
    GetNameForTeam(teamid) {
      var foundTeam = this.teams.find((innerItem) => innerItem.id == teamid);

      if (foundTeam != null) return foundTeam.teamName;
      else return "Deleted Team";
    },
    ApplyChanges() {
      this.UpdateSectionCatalogue({
        id: this.section.id,
        catalogue: this.catalogue,
      }).then(() => {
        this.hasBeenChanges = false;
      });
    },
  },
};
</script>

<style></style>
